import { Environment } from '@dice/app/types/env.type';
import { DEV_ENV_CONFIG } from '@dice/environments/dev/dev.env';
import { NgxLoggerLevel } from 'ngx-logger';

export const DEV_MASTERDATA_ENV_CONFIG: Environment = {
  ...DEV_ENV_CONFIG,
  hostNames: ['dice-dev-masterdata.dev-scapp-corp.swisscom.com', 'localhost:3001'],
  enableDebugInfo: true,
  isProduction: false,
  variant: 'dice-ui-dev-masterdata',
  logLevel: NgxLoggerLevel.DEBUG,

  budaConfigurationEndpoint: `https://buda-masterdata-test.scapp-corp.swisscom.com/`,
  wsEndpoint: `wss://buda-message-proxy-test.scapp-corp.swisscom.com/`,
  wsEndpointForUCCP: `wss://buda-message-proxy-uccp-test.scapp-corp.swisscom.com/`,
  budaStatisticsConsumerEndpoint: 'https://buda-message-proxy-test.scapp-corp.swisscom.com/',
  budaStatisticsConsumerEndpointForUCCP: 'https://buda-message-proxy-uccp-test.scapp-corp.swisscom.com/',
  agentViewStatisticsConsumerEndpoint: `https://buda-message-proxy-agentview-test.scapp-corp.swisscom.com/`,
  agentInfoStatisticsConsumerEndpoint: `https://buda-message-proxy-agentinfo-test.scapp-corp.swisscom.com/`,
};
